import IndicadoresApi from "../api/IndicadoresApi";

class IndicadoresService {


    async recuperarTodos() {
        return await IndicadoresApi.recuperarTodos();
    }
}

export default new IndicadoresService();